<!-- V1 -->
<!-- <ul class="social-icons animated fadeInUp">
    <li *ngFor="let item of sosyalMedya"><a [attr.aria-label]="item?.ad" class="fab fa-{{item?.ad}}" 
            href="{{item?.url}}" rel="nofollow noopener" target="_blank"></a></li>
</ul> -->

<!-- V2 -->
<ul class="social-icons animated fadeInUp">
    <li *ngFor="let item of sosyalMedya"><a [attr.aria-label]="item?.ad" class="fab fa-{{item?.ad}}" 
            href="{{item?.url}}" rel="nofollow noopener" target="_blank"></a></li>
</ul>




